module.exports = __webpack_public_path__ + "img/h5-item-2.b7220c08.png";